import React, { useState, useEffect } from "react";
import {
    Button,
    CardBody,
    Col,
    FormInput,
    FormRadio,
    Row,
} from "shards-react";
import Select from "react-select";
import { partners as partnersList } from './SelectList/Partners';
import * as statuses from '../SelectList/Status';
import { getMarkup } from '../SelectList/StatusMarkup';
import { getPaymentStatusName } from '../SelectList/PaymentsStatus';
import moment from "moment";
import Auth from "../../../auth";

const Filters = ({onDataReceived, allowAccess}) => {
    const [selectedOption, setSelectedOption] = useState('live');
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [status, setStatus] = useState([]);
    const [markup, setMarkup] = useState([]);
    const [paymentsStatus, setPaymentsStatus] = useState([]);
    const [partners, setPartners] = useState([]);
    const [doNotRefreshOnFirstRender, setDoNotRefreshOnFirstRender] = useState(true);

    useEffect(() => {
        initFilterWithSavedData();
    }, []);

    const initFilterWithSavedData = () => {
        setDataSaved(JSON.parse(localStorage.getItem('typeSaved')), '', setSelectedOption);
        setDataSaved(localStorage.getItem('startDate'), '', setStartDate);
        setDataSaved(localStorage.getItem('endDate'), '', setEndDate, );
        setDataSaved(localStorage.getItem('statusSaved'), [], setStatus, true)
        setDataSaved(localStorage.getItem('paymentStatusSaved'), [], setPaymentsStatus, true)
        setDataSaved(localStorage.getItem('markupSaved'), [], setMarkup, true)
        setDataSaved(localStorage.getItem('partnerSaved'), [], setPartners, true)
    }

    const setDataSaved = (
        savedValue,
        initialValue,
        methodForSetValue,
        isArray = false
    ) => {
        if (savedValue === null
            || savedValue === ""
        ) {
            methodForSetValue(initialValue);
        } else {
            if (isArray) {
                savedValue = JSON.parse(savedValue);
            }

            methodForSetValue(savedValue);
        }
    }

    useEffect(() => {
        if (doNotRefreshOnFirstRender) {
            setDoNotRefreshOnFirstRender(false);
        } else {
            const date = formattedDate();

            sendOptionsFilter(
                date.start,
                date.end,
                status,
                partners,
                paymentsStatus,
                markup
            );
        }
    }, [
        selectedOption,
        startDate,
        endDate,
        status,
        paymentsStatus,
        partners,
        markup
    ]);

    const formattedDate = () => {
        const isLive = selectedOption === "live";
        const start = isLive ? moment().startOf('day').format('YYYY-MM-DD HH:mm:ss') : startDate + ' 00:00:00';
        const end = isLive ? moment().endOf('day').format('YYYY-MM-DD HH:mm:ss') : endDate + ' 23:59:59';

        return {start, end};
    }

    const sendOptionsFilter = (
        startDate,
        endDate,
        status,
        partners,
        paymentsStatus,
        markup
    ) => {
        const paramsUrl = {
            start: startDate,
            end: endDate,
            status: status,
            partners: partners,
            paymentsStatus: paymentsStatus,
            markup: markup,
            page: 1,
        }

        onDataReceived(paramsUrl);
    }

    const sendDataToFilters = async () => {
        const date = formattedDate();

        sendOptionsFilter(
            date.start,
            date.end,
            status,
            partners,
            paymentsStatus,
            markup
        );
    };

    const handleChangeDate = (event, propsName, callback) => {
        const endDate = event !== '' ? event.target.value : '';
        localStorage.setItem(propsName, endDate);
        callback(endDate);
    };

    const handleChangeSelect = (selected, propsName, callback) => {
        localStorage.setItem(propsName, JSON.stringify(selected));
        callback(selected);
    }

    const getToken = () => {
        const auth = new Auth();
        const token = auth.getAccessToken();
        return token ? auth.parseJwt(token) : '';
    }

    const isAllowed = () => {
        const jwtToken = getToken();

        return jwtToken.username === undefined;
    };

    allowAccess(isAllowed())

    return (
        <CardBody>
            <Row className="mx-auto">
                <Col className="mx-auto pr-0 pl-0">
                    <p className="mb-2"> Date </p>
                    <Row>
                        <div className="ml-4">
                            <FormRadio
                                name = "date"
                                value = 'live'
                                checked = { selectedOption === 'live' }
                                onChange = { () => handleChangeSelect(
                                    'live',
                                    'typeSaved',
                                    setSelectedOption
                                )}
                            >
                                Live
                            </FormRadio>
                        </div>
                        <div className="ml-4">
                            <FormRadio
                                className = "ml-3"
                                name = "date"
                                value = 'history'
                                checked = { selectedOption === 'history' }
                                onChange = { () => handleChangeSelect(
                                    'history',
                                    'typeSaved',
                                    setSelectedOption
                                ) }
                            >
                                Historique
                            </FormRadio>
                        </div>
                    </Row>
                    {selectedOption === "history" && (
                        <Row className="ml-auto">
                            <div className="mr-3">
                                <span className="mb-2"> Début </span>
                                <FormInput
                                    id = "start"
                                    type = 'date'
                                    value = { startDate }
                                    onChange = { (selectedDate) => handleChangeDate(
                                        selectedDate,
                                        'startDate',
                                        setStartDate
                                    ) }
                                />
                            </div>
                            <div>
                                <span> Fin </span>
                                <FormInput
                                    id = "end"
                                    type = 'date'
                                    value = { endDate }
                                    onChange = { (selectedDate) => handleChangeDate(
                                        selectedDate,
                                        'endDate',
                                        setEndDate
                                    ) }
                                />
                            </div>
                        </Row>
                    )}
                </Col>
            </Row>
            <Row className="mt-3">
                <Col className="col-lg lg-6 mb-12 col-lg-6 mb-12">
                    <p className="mb-2"> État du rendez-vous: </p>
                    <Select
                        isMulti
                        name = "status"
                        options = { statuses.list() }
                        className = "basic-multi-select"
                        classNamePrefix = "status"
                        value = { status }
                        onChange = {(statusSelected) => handleChangeSelect(
                            statusSelected,
                            'statusSaved',
                            setStatus
                        )}
                        labelledBy = "status"
                    />
                </Col>
                {/* add when filters by payment status made*/}
                <Col className="col-lg lg-6 mb-12 col-lg-6 mb-12">
                    <p className="mb-2"> Statut de paiement: </p>
                    <Select
                        isMulti
                        name = "paymentsStatus"
                        options = { getPaymentStatusName() }
                        className = "basic-multi-select"
                        classNamePrefix = "paymentsStatus"
                        value = { paymentsStatus }
                        onChange = { (statusSelected) => handleChangeSelect(
                            statusSelected,
                            'paymentStatusSaved',
                            setPaymentsStatus
                        )}
                        labelledBy = "paymentsStatus"
                    />
                </Col>
            </Row>
            <Row className="mt-3">
                {isAllowed() ? (
                    <Col className="col-lg lg-6 mb-12 col-lg-6 mb-12">
                        <p className="mb-2"> Markup: </p>
                        <Select
                            isMulti
                            name = "markup"
                            options = { getMarkup() }
                            className = "basic-multi-select"
                            classNamePrefix = "markup"
                            value = { markup }
                            onChange = { (selectedMarkup) => handleChangeSelect(
                                selectedMarkup,
                                'markupSaved',
                                setMarkup
                            )}
                            labelledBy = "markup"
                        />
                    </Col>
                ) : (
                    <Col className="col-lg lg-6 mb-12 col-lg-6 mb-12 pl-0 pr-0" />
                )}
                <Col className="col-lg lg-6 mb-12 col-lg-6 mb-12">
                    {isAllowed() ? (
                        <div>
                            <p className="mb-2"> Partenaires: </p>
                            <Select
                                isMulti
                                name = "partners"
                                options = { partnersList() }
                                className = "basic-multi-select"
                                classNamePrefix = "partners"
                                value = { partners }
                                onChange = { (selectedPartner) => handleChangeSelect(
                                    selectedPartner,
                                    'partnerSaved',
                                    setPartners
                                )}
                                labelledBy = "partners"
                            />
                        </div>
                    ) : (
                        <Col className="col-lg lg-6 mb-12 col-lg-6 mb-12 pl-0 pr-0" />
                    )}
                </Col>
            </Row>
            <Row className="mx-auto">
                <Col md="6" className="text-right align-self-end mt-3">
                    <Button
                        type = 'submit'
                        className = "block-center"
                        onClick = { sendDataToFilters }
                    >
                        Rechercher
                    </Button>
                </Col>
            </Row>
        </CardBody>
    );
};

export default Filters;


// WEBPACK FOOTER //
// ./src/views/Dashboardlive/Filters/Filters.js